import { createRequestHelper } from '@utils/swr'
import { type CountryListResponse } from '../../../types/apiResponse'
import { type CosignApis } from '../../../types/apis'

const {
  useRequest,
} = createRequestHelper<CosignApis['get']['countryList'], CountryListResponse, { 'x-platform-id': string }>({
  client: 'cosign',
  key: params => params?.['x-platform-id'] ? `/api/platform-sdk/country-list?x-platform-id=${params['x-platform-id']}` : null,
  fetcher: client => (url, params) =>
    client.get(url, {
      params,
      headers: {
        'x-platform-id': params?.['x-platform-id'],
      },
    }),
  isImmutable: true,
})

export const useRequestCountryList = useRequest
